var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleQuestion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.4,
    height: 15.4,
    viewBox: "0 0 15.4 15.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-question",
    d: "M14.438,7.7A6.737,6.737,0,1,0,7.7,14.438,6.738,6.738,0,0,0,14.438,7.7ZM0,7.7a7.7,7.7,0,1,1,7.7,7.7A7.7,7.7,0,0,1,0,7.7ZM5.074,5.107A1.686,1.686,0,0,1,6.7,3.85H8.422A1.934,1.934,0,0,1,9.3,7.5L8.181,8.07v.593a.481.481,0,0,1-.963,0V7.775a.489.489,0,0,1,.262-.43l1.378-.7a.971.971,0,0,0-.436-1.835H6.7a.721.721,0,0,0-.7.538L6,5.366a.48.48,0,0,1-.929-.244L5.077,5.1Zm1.9,5.48a.722.722,0,1,1,.722.722A.722.722,0,0,1,6.978,10.588Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-question.2c5e5365c66f895fbbcb09bd036cfa81.svg";